import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import Footer from "../components/Footer"
import NavBar from "../components/NavBar"
import SEO from "../components/Seo"
import impact_1 from "../images/impact_1.png"
import impact_2 from "../images/impact_2.png"
import impact_3 from "../images/impact_3.png"
import impact_4 from "../images/impact_4.png"
import { useTranslation } from "react-i18next"

export default function ImpactTemplate({
  pageContext: {
    impact: { header, body, message, image },
  },
}) {
  const { t } = useTranslation()
  const SelectedImage =
    image === "impact_1.png"
      ? impact_1
      : image === "impact_2.png"
      ? impact_2
      : image === "impact_3.png"
      ? impact_3
      : impact_4
  return (
    <div>
      <SEO title={t(header)} description={t(body)} />
      <NavBar />
      <section className="employment-area bg-light" id="employment">
        <div className="employment-header bg-white">
          <Container>
            <Row>
              <Col lg={12}>
                <h1 className="title-section-inside mt-25">&lt; {t(header)}</h1>
              </Col>
            </Row>
          </Container>
        </div>
        <Container>
          <Row>
            <Col lg={12} className="text-center">
              <img
                className="img-fluid employment-img shadow"
                src={SelectedImage}
                alt={t(header)}
              ></img>
            </Col>
          </Row>
          <Row className="employment-content">
            <Col lg={12}>
              <p className="description">{t(body)}</p>
            </Col>
          </Row>
          <Row className="employment-content">
            <Col lg={12}>
              <p className="description">{t(message)}</p>
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
    </div>
  )
}
